import React, { useState, useEffect, useRef, useContext } from 'react';
import { useSelector } from 'react-redux';
import { AnchorWithLink } from 'atoms/Anchor';
import ImageComponent from 'atoms/Image';
import SEARCH_STORE_CONSTANTS from '../Constants/SearchStoreConstants';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { UserOrderContext } from 'context/context';
import { ButtonComp } from 'atoms/Buttons';
import MyMapComponent from './MapComponent';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import {
  callUtilFunct,
  deliveryModuleAnalyticFn,
  localisationViewAnalyticsData,
  setUseMyLocationAnalytics,
  checkAddressPresentInLocalStorage,
} from '../SearchStoreUtilities/SearchStoreUtils';
import {
  getValueOrDefaultAlternativeObject,
  getValueOrDefaultArray,
  getValueOrDefaultObject,
  getAndCheck,
  getTernaryValue,
  addressSuggestionLengthMatch,
  getLength,
  manipulateAlreadySearchedLocations,
  getEmbeddedErrorMessageAnalytic,
} from 'common/utilities/utils';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';
import SavedAddress from './SavedAddress';
import NegativeScenarioErros from './NegativeScenarioErros';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { Config, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { ChannelManager } from 'common/manager';
import SEARCHSTORE_MODULE_DATA from 'organisms/SearchStore/Data/Defaults';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const { LocationImage, GoogleMapLocationImage, SuggestionItemSearchPin, clearTextIcon, Time_Clock, Error, MapImage } =
  IMAGE_PATH;

const {
  MIN_SEARCH_CHARACTER_LIMIT,
  SUUGESTED_ITEMS_TEXT,
  ALLOWED_SUGGESTION_LIST: allowedSuggestionList,
  ALREADY_SERACHED_LOCATIONS,
  COUNTRY_CODE: countryCode,
  SUGGESTION_ACTIVE_COLOR: suggestionHighLightColor,
  SUGGESTION_ACTIVE_OPACITY: suggestionOpacity,
  BRAND_BLACK: brandBlack,
  COLOR_BLACK: black,
  CONFIRM_BUTTON_TEXT,
  LOCATION_WARNING_MESSAGE,
  RETRY_TEXT,
  USE_THIS_ADDRESS_TEXT,
  DELIVERY_UNAVAILABLE,
  DELIVERY_UNAVAILABLE_WITH_CTA,
  NOTAVAILABLE,
  CTA1_SEARCH_DIFF_ADDRESS,
  TAKE_AWAY,
  CTA2_ORDER_TAKEAWAY,
} = SEARCH_STORE_CONSTANTS;

const onSearchError = (status, clearSuggestions) => {
  clearSuggestions();
};
const setStateForSuggestedAddress = (val, setSuggestedAddress, setShowAutoSuggestion) => {
  if (val?.length < 3) {
    setSuggestedAddress('');
    setShowAutoSuggestion(false);
  }
};
const checkNegativeScanariosForDelivery = ({
  eligibleStoreData,
  suggestedAddress,
  setNegativeScenarioAlert,
  getNegativeView,
}) => {
  // -ve Scenarios for delivery
  let finalEligibleStoreData = eligibleStoreData?.filter(storeInfo => storeInfo?.summary?.menu?.catalogs?.length > 0);

  // To check Scinario: EMERGENCY_SHUTDOWN
  let closedEmergencyStoreList = finalEligibleStoreData.filter(store => {
    const isClosed = store.summary.status.currentStatus === 'CLOSED';
    const isEmergencyShutdown = store?.summary?.status?.message?.indexOf('EMERGENCY_SHUTDOWN') !== -1;
    const isTechnicalShutdown = store?.summary?.status?.message?.indexOf('TECHNICAL_SHUTDOWN') !== -1;
    return isClosed && (isEmergencyShutdown || isTechnicalShutdown);
  });

  let errorMsg = callUtilFunct('delivery', finalEligibleStoreData);
  if (
    getValueOrDefaultAlternativeObject(
      errorMsg,
      getValueOrDefaultAlternativeObject(
        !suggestedAddress[0]?.description,
        closedEmergencyStoreList?.length === finalEligibleStoreData.length,
      ),
    )
  ) {
    if (
      getAndCheck(closedEmergencyStoreList?.length === finalEligibleStoreData?.length, finalEligibleStoreData?.length)
    ) {
      errorMsg = DELIVERY_UNAVAILABLE;
    }
    // To check not suggested address condition not found Scinario:4
    else if (!suggestedAddress[0]?.description) {
      errorMsg = DELIVERY_UNAVAILABLE_WITH_CTA;
    }
    setNegativeScenarioAlert(errorMsg);
    getEmbeddedErrorMessageAnalytic(
      translateWithI18Next(SEARCHSTORE_MODULE_DATA.contentData.deliveryHeaderText),
      translateWithI18Next(errorMsg),
    );
    return getNegativeView(errorMsg);
  } else {
    return;
  }
};

const getConfirmButton = (confirm, isLoading, onAddressConfirmHandler) => {
  return (
    <ButtonComp
      className='button blackButton blackBorder delivery-confirm-button delivery-confirm-button-in'
      data-testid='btn-confirm'
      disabled={!confirm || isLoading}
      onClick={onAddressConfirmHandler}
      data-loading={isLoading}
    >
      {translateWithI18Next(CONFIRM_BUTTON_TEXT)}
    </ButtonComp>
  );
};

export const DeliveryModuleForm = props => {
  const { formContent = {}, userPositionHandler, singInClickhandler, eligibleStoreData } = props;
  const {
    memberText = '',
    singInLink = {},
    currentLocationText = '',
    addressBoxPlaceHolderForDelivery = '',
  } = formContent;
  const { RETAIN_ADDRESS } = LOCAL_STORAGE_KEYS;
  const { SCHEDULE_ORDER_DATA, DISPOSITION_METHOD } = START_ORDER_CONSTANTS;
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const { loggedIn } = getValueOrDefaultObject(userParams);
  // get the context from parent
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { searchStoreData = {}, dispositionStateData = {} } = userOrderState;
  const [address, setAddress] = useState('');
  const [confirm, setConfirm] = useState(false);
  const [useMyLocationClick, setUseMyLocationClick] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [latLongValues, setLatLongValues] = useState({ lat: 28.7, lng: 77.1 });
  const [autoSuggestionSelectedFlag, setAutoSuggestionSelectedFlag] = useState(false);
  const [locationAlert, setLocationAlert] = useState(false);
  const [suggestedAddress, setSuggestedAddress] = useState([]);
  const [firstSuggestedAddress, setFirstSuggestedAddress] = useState('');
  const inputRef = useRef(null);
  const [backupUseMyLocation, setBackupUseMyLocation] = useState('');
  const [negativeScenarioAlert, setNegativeScenarioAlert] = useState('');
  const [clickedAutoSuggestion, setClickedAutoSuggestion] = useState(false);
  const [showAutoSuggestion, setShowAutoSuggestion] = useState(false);
  const [errorForStore_savedAddress, setErrorForStore_savedAddress] = useState(false);
  const [addFromSavedOne, setAddFromSavedOne] = useState('');
  const [isFromSavedStore, setIsFromSavedStore] = useState(false);
  const { dispositionType = localStorage.getItem('dispositionType') } = dispositionStateData;
  const [userPositions, setUserPositions] = useState({});

  const isLoading = useSelector(state => {
    return (
      state.storesReducer?.isGoogleDistanceLoading ||
      state.storesReducer?.isStoreStatusLoading ||
      state.storesReducer?.isNearByStoresLoading ||
      state.storesReducer?.isStoreTimeSlotsLoading
    );
  });

  useEffect(() => {
    deliveryModuleAnalyticFn(locationAlert, negativeScenarioAlert, SEARCHSTORE_MODULE_DATA);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationAlert, negativeScenarioAlert]);

  const getNegativeView = (errorMsg = '') => {
    return (
      <React.Fragment>
        <NegativeScenarioErros
          errorMsgToShow={getValueOrDefaultAlternativeObject(negativeScenarioAlert, errorMsg)}
          onClearTextHandler={onClearTextHandler}
          onRetryClickHandler={onRetryClickHandler}
          onMapClickHandler={onMapClickHandler}
          dispositionType={dispositionType}
          showMap={showMap}
        />
      </React.Fragment>
    );
  };

  const onAddressConfirmHandler = e => {
    e.preventDefault();
    if (isFromSavedStore) {
      errorForStore_savedAddress && setConfirm(false);
      startOrderFormSavedAddress(address, userPositions);
      return;
    }
    if (
      (clickedAutoSuggestion &&
        checkNegativeScanariosForDelivery({
          eligibleStoreData,
          suggestedAddress,
          setNegativeScenarioAlert,
          getNegativeView,
        })) ||
      (!suggestedAddress[0]?.description &&
        checkNegativeScanariosForDelivery({
          eligibleStoreData,
          suggestedAddress,
          setNegativeScenarioAlert,
          getNegativeView,
        }))
    ) {
      return;
    }
    setNegativeScenarioAlert('');

    if (!autoSuggestionSelectedFlag) {
      const addressDetails = suggestedAddress[0]?.description;
      setFirstSuggestedAddress(addressDetails);
      suggestedAddress[0]?.description && setLocationAlert(true);
      setConfirm(false);
      handleSelectAddress(addressDetails, suggestedAddress?.placeId, suggestedAddress, true);
      return;
    }

    if (!eligibleStoreData[0]) {
      return;
    }
    setAutoSuggestionSelectedFlag(false);
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: {
        deliveryAddress: address,
        showScheduleOrderCatering: true,
        selectedStoreInfo: eligibleStoreData[0],
      },
    });
  };

  const onMapClickHandler = (e, set = '', defaultAddress = '') => {
    e.preventDefault();
    localisationViewAnalyticsData(showMap, dispositionType);
    setShowMap(true);
    setNegativeScenarioAlert(false);
    defaultAddress && !address && handleSelectAddress(defaultAddress);
  };

  const stringReducer = prop => {
    const words = prop.toString()?.split(' ');
    const filteredWord = words?.filter(e => !e?.includes('+'));
    return filteredWord?.join(' ');
  };

  const onRetryClickHandler = e => {
    inputRef.current.select();
    setConfirm(false);
    setAutoSuggestionSelectedFlag(false);
    setNegativeScenarioAlert(false);
    setLocationAlert(false);
  };

  const onUseThisAddressHandler = async e => {
    const checkNegativeScenarioForDeliveryResults = checkNegativeScanariosForDelivery({
      eligibleStoreData,
      suggestedAddress,
      setNegativeScenarioAlert,
      getNegativeView,
    });
    if (
      (address.length > 0 && locationAlert && checkNegativeScenarioForDeliveryResults) ||
      (!eligibleStoreData[0] && checkNegativeScenarioForDeliveryResults)
    ) {
      return;
    }
    if (suggestedAddress[0]?.description) {
      userOrderStateDispatch({
        type: SCHEDULE_ORDER_DATA,
        value: {
          deliveryAddress: firstSuggestedAddress,
          showScheduleOrderCatering: true,
          selectedStoreInfo: getValueOrDefaultObject(eligibleStoreData[0]),
        },
      });
    }

    setAutoSuggestionSelectedFlag(false);
  };

  const handleSelectAddress = async (value, placeId, suggestion, manualSelecteAddress = false) => {
    setIsFromSavedStore(false);
    setAddFromSavedOne('');
    // user did not select auto suggestion and pressed Enter;
    let nullCheck = getAndCheck(placeId === null, suggestion === null);
    nullCheck && suggestedAddress[0]?.description && setLocationAlert(true);
    setClickedAutoSuggestion(true);
    setAutoSuggestionSelectedFlag(true);
    const results = await geocodeByAddress(value);
    const latLong = await getLatLng(results[0]);
    setLatLongValues(latLong);
    setLocalStorage(value);
    const finalValue = stringReducer(value);
    setAddress(finalValue);
    if (!manualSelecteAddress) {
      setConfirm(true);
    }
    userPositionHandler({ userLat: latLong.lat, userLong: latLong.lng });
    setUseMyLocationClick(false);
  };

  useEffect(() => {
    let retainAddress = localStorage?.getItem(RETAIN_ADDRESS);
    //RENDEV-10899 calling function only if retainAdress is present
    checkAddressPresentInLocalStorage(retainAddress, setSuggestedAddress, handleSelectAddress);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let finalEligibleStoreData = eligibleStoreData?.filter(
      storeInfo => storeInfo?.summary?.menu?.catalogs[0] !== NOTAVAILABLE,
    );

    let finalEligibleStoreData1 = finalEligibleStoreData?.filter(
      storeInfo => storeInfo?.summary?.status?.currentStatus !== 'CLOSED',
    );
    if (isFromSavedStore && addFromSavedOne && finalEligibleStoreData1 && finalEligibleStoreData1?.length >= 1) {
      setErrorForStore_savedAddress(false);
      userOrderStateDispatch({
        type: SCHEDULE_ORDER_DATA,
        value: {
          deliveryAddress: addFromSavedOne,
          showScheduleOrderCatering: true,
          selectedStoreInfo: finalEligibleStoreData1[0],
        },
      });
      // }
    } else {
      addFromSavedOne && setErrorForStore_savedAddress(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eligibleStoreData, addFromSavedOne, isFromSavedStore]);

  useEffect(() => {
    //called when latLong values are set
  }, [latLongValues]);

  const setConfirmVal = () => {
    setConfirm(false);
    setLocationAlert(false);
    setNegativeScenarioAlert('');
  };

  useEffect(() => {
    address?.length > 2 ? setConfirm(!locationAlert) : setConfirmVal();
    let autoSuggestionCondition = addressSuggestionLengthMatch(address, MIN_SEARCH_CHARACTER_LIMIT);
    setShowAutoSuggestion(autoSuggestionCondition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  useEffect(() => {
    /**
     * populate input text box when user select use my location
     */
    if (useMyLocationClick) {
      const finalBackupUseMyLocation = stringReducer(backupUseMyLocation);
      setAddress(finalBackupUseMyLocation);
      setLocalStorage(backupUseMyLocation);
      setUseMyLocationClick(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchStoreData]);

  /**
   * Mehtod to store search value to locastorage
   * @param {*} value representing user's selection
   */
  const setLocalStorage = value => {
    manipulateAlreadySearchedLocations(value, ALREADY_SERACHED_LOCATIONS);
  };
  /**
   * Mehtod to search value from locastorage
   * @param {*} description representing seggestion's description
   */
  const getLocalStorage = description => {
    const allSeachedLocations = getValueOrDefaultArray(JSON.parse(localStorage.getItem(ALREADY_SERACHED_LOCATIONS)));
    return allSeachedLocations.includes(description);
  };

  const inputOnChange = val => {
    setClickedAutoSuggestion(false);
    setAutoSuggestionSelectedFlag(false);
    const finalVal = stringReducer(val);
    setAddress(finalVal);
    setStateForSuggestedAddress(val, setSuggestedAddress, setShowAutoSuggestion);
    setIsFromSavedStore(false);
    setAddFromSavedOne('');
    setErrorForStore_savedAddress(false);
  };

  /**
   * method to get the lat and long data when user choose's current location
   */
  const useCurrentLocation = async () => {
    localisationStartAnalytics();
    await ChannelManager.BindLocation();
    setUseMyLocationAnalytics();
    setSuggestedAddress([]);
    if (ChannelManager.coordinates) {
      const { latitude: userLat, longitude: userLong } = ChannelManager.coordinates;

      ChannelManager.addFeedback(`Check coordinates ${JSON.stringify(ChannelManager.coordinates)}`);
      ChannelManager.addFeedback(`Check assignment ${JSON.stringify({ userLat, userLong })}`);
      ChannelManager.addFeedback(`Check address ${ChannelManager.address}`);
      userPositionHandler({ userLat, userLong });
      setBackupUseMyLocation(ChannelManager.address);
      const finalChannelManagerAddress = stringReducer(ChannelManager.address);
      setAddress(finalChannelManagerAddress);
      handleSelectAddress(ChannelManager.address);
      setUseMyLocationClick(true);
      setSuggestedAddress([{ description: ChannelManager.address }]);
    }
  };
  /**
   *
   * @param {*} value - Method to check if the user has already serached for this location earlier or not
   */
  const alreadySearched = value => {
    return getLocalStorage(value);
  };

  const onClearTextHandler = () => {
    setAddress('');
    setConfirm(false);
    setNegativeScenarioAlert('');
    setSuggestedAddress('');
    setErrorForStore_savedAddress(false);
  };
  const passAddress = addr => {
    const finalAddr = stringReducer(addr);
    setAddress(finalAddr);
  };

  const startOrderFormSavedAddress = async (savedAddress, savedUserPosition) => {
    setLatLongValues({ lat: savedUserPosition.userLat, lng: savedUserPosition.userLong });
    setIsFromSavedStore(true);
    const finalSavedAddress = stringReducer(savedAddress);
    setAddress(finalSavedAddress);
    setUserPositions(savedUserPosition);
    setLocalStorage(savedAddress);
    // To check Scinario: CLOSED || EMERGENCY_SHUTDOWN
    setAddFromSavedOne(savedAddress);
    userPositionHandler(savedUserPosition);
  };
  return (
    <React.Fragment>
      <div className='delivery-module-form' data-testid='delivery-component'>
        <div>
          <div className='login-section'>
            <span className='delivery-member-signin'>
              {!loggedIn && showLoginLinkForNonLoggedInUsers(memberText, singInClickhandler, singInLink)}
            </span>
            <span>
              <AnchorWithLink
                onClickHandler={useCurrentLocation}
                className='delivery-location-link'
                data-testid='use-my-location'
              >
                <ImageComponent data-testid='' srcFile={LocationImage} alt=' ' className='location-img' />
                {translateWithI18Next(currentLocationText)}
              </AnchorWithLink>
            </span>
          </div>
          <div className='delivery-address-section'>
            <div className='search-delivery-address'>
              <div className='input-delivery-address'>
                <PlacesAutocomplete
                  value={address}
                  onChange={inputOnChange}
                  onSelect={handleSelectAddress}
                  searchOptions={{
                    componentRestrictions: { country: countryCode },
                  }}
                  shouldFetchSuggestions={true}
                  onError={onSearchError}
                >
                  {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                    <div>
                      <ImageComponent
                        data-testid=''
                        srcFile={GoogleMapLocationImage}
                        alt=' '
                        className='google-location-img'
                      />
                      <input
                        data-testid='store-search-input'
                        aria-label='Enter your delivery address'
                        className={`${getTernaryValue(
                          getValueOrDefaultAlternativeObject(locationAlert, negativeScenarioAlert),
                          'store-search-input error-border mt-2',
                          'store-search-input mt-2',
                        )}`}
                        {...getInputProps({
                          placeholder: translateWithI18Next(addressBoxPlaceHolderForDelivery),
                          ref: inputRef,
                        })}
                      />
                      {address && (
                        <img
                          src={clearTextIcon}
                          className='clearTextIcon'
                          onClick={onClearTextHandler}
                          alt='Clear Text Icon'
                        />
                      )}
                      {getAndCheck(getLength(suggestions), showAutoSuggestion) ? (
                        <div className='suggestion-list'>
                          {suggestions.map((suggestion, index) => {
                            if (suggestion?.types?.some(itemType => allowedSuggestionList.includes(itemType))) {
                              setSuggestedAddress(suggestions);
                              const style = getTernaryValue(
                                suggestion.active,
                                {
                                  backgroundColor: suggestionHighLightColor,
                                  opacity: suggestionOpacity,
                                },
                                { backgroundColor: brandBlack },
                              );
                              return (
                                <React.Fragment>
                                  {index === 0 && (
                                    <div className='suggestion-items suggest-text'>
                                      {translateWithI18Next(SUUGESTED_ITEMS_TEXT)}
                                    </div>
                                  )}
                                  <div style={style}>
                                    <div
                                      key={index}
                                      {...getSuggestionItemProps(suggestion, {
                                        className: 'suggestion-items',
                                      })}
                                    >
                                      <div className='suggested-address-alignment-delivery'>
                                        <div>
                                          <ImageComponent
                                            data-testid=''
                                            srcFile={getTernaryValue(
                                              alreadySearched(suggestion.description),
                                              Time_Clock,
                                              SuggestionItemSearchPin,
                                            )}
                                            alt={'googleMapLocation'}
                                            className='suggetion-pin'
                                          />
                                        </div>
                                        <div className='suggestion-description'>{suggestion.description}</div>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            }
                          })}
                        </div>
                      ) : null}
                    </div>
                  )}
                </PlacesAutocomplete>
              </div>
            </div>
            <form>{getConfirmButton(confirm, isLoading, onAddressConfirmHandler)}</form>
          </div>
        </div>

        {/* Temp addreess for saved address */}
        {errorForStore_savedAddress && !isLoading && (
          <div className='error-popup-saved-address error-popup-saved-address-map-view1'>
            <ImageComponent srcFile={Error} className='location-alert-icon' />

            <div className='location-error-address'>{translateWithI18Next(DELIVERY_UNAVAILABLE)}</div>
            <div className='location-error-button-section'>
              <ButtonComp
                data-testid='btn-searchDifferentAddressClick'
                className='button whiteButton blackBorder location-warning-button mr'
                onClickHandler={e => setErrorForStore_savedAddress(false)}
              >
                {translateWithI18Next(CTA1_SEARCH_DIFF_ADDRESS)}
              </ButtonComp>
              <ButtonComp
                data-testid='btn-orderTakeawayClick'
                className='button whiteButton blackBorder location-warning-button ml'
                onClickHandler={e => {
                  e.preventDefault();
                  userOrderStateDispatch({ type: DISPOSITION_METHOD, value: { dispositionType: TAKE_AWAY } });
                }}
              >
                {translateWithI18Next(CTA2_ORDER_TAKEAWAY)}
              </ButtonComp>
            </div>
          </div>
        )}

        {!showMap && <div className='my-3 store-form-separation' />}
        {!showMap && !loggedIn && !locationAlert && !negativeScenarioAlert
          ? displaySectionWhenThereAreNoNegativeScenarios(onMapClickHandler)
          : null}
        {!locationAlert && loggedIn && !negativeScenarioAlert && !showMap && !errorForStore_savedAddress && (
          <SavedAddress
            userPositionHandler={userPositionHandler}
            startOrderFormSavedAddress={startOrderFormSavedAddress}
            allowOrderNow={errorForStore_savedAddress}
            onMapClickHandler={onMapClickHandler}
          />
        )}
      </div>
      {address.length > 0 && getAndCheck(locationAlert, !negativeScenarioAlert) ? (
        <div data-testid='alert-locationid' className='alert-location-popup'>
          <ImageComponent srcFile={Error} className='location-alert-icon' />
          <div className='location-error-message'>{translateWithI18Next(LOCATION_WARNING_MESSAGE)}</div>
          <div className='location-error-address'>
            {getValueOrDefaultAlternativeObject(suggestedAddress[0]?.description, address)}
          </div>
          <div className='location-error-button-section'>
            <ButtonComp
              className='button whiteButton blackBorder location-warning-button mr'
              onClick={onRetryClickHandler}
            >
              {translateWithI18Next(RETRY_TEXT)}
            </ButtonComp>
            <ButtonComp
              className='button whiteButton blackBorder location-warning-button ml'
              data-testid='use-this-address'
              onClick={onUseThisAddressHandler}
            >
              {translateWithI18Next(USE_THIS_ADDRESS_TEXT)}
            </ButtonComp>
          </div>
        </div>
      ) : (
        negativeScenarioAlert && getNegativeView()
      )}
      {/* <div className={`delivery-map ${getTernaryValue(locationAlert , 'pointer-disabled' , '')}`}> */}
      {showMap ? displayMap(locationAlert, latLongValues, passAddress, negativeScenarioAlert) : null}
      {/* </div> */}
    </React.Fragment>
  );
};

export default DeliveryModuleForm;

function displayMap(locationAlert, latLongValues, passAddress, negativeScenarioAlert) {
  return (
    <div className={`delivery-map deliver-map-zoom ${getTernaryValue(locationAlert, 'pointer-disabled', '')}`}>
      <div data-testid='view-map-div' className='view-map'>
        <MyMapComponent
          data-testid='map-comp'
          latLongValue={latLongValues}
          passAddress={passAddress}
          locationAlertProp={locationAlert}
          negativeScenarioAlertProp={negativeScenarioAlert}
          locationAlert={locationAlert}
        />
      </div>
    </div>
  );
}

function displaySectionWhenThereAreNoNegativeScenarios(onMapClickHandler) {
  return (
    <div className='map-button-form'>
      <div className='show-map-div' data-testid='show-map-div' onClick={onMapClickHandler}>
        <span className='delivery-map-text'>{translateWithI18Next('pleaseEnterLocation')}</span>
        <AnchorWithLink className='map-link'>
          <span>
            <ImageComponent data-testid='' srcFile={MapImage} alt=' ' className='map-img' />
          </span>
          {translateWithI18Next('map')}
        </AnchorWithLink>
      </div>
    </div>
  );
}

function showLoginLinkForNonLoggedInUsers(memberText, singInClickhandler, singInLink) {
  return (
    <div data-id={Config.HEADER_SIGN_IN_ATTR_DATA_ID}>
      {translateWithI18Next(memberText)}
      <span onClick={singInClickhandler}>
        <AnchorWithLink targetType={singInLink.targetType} href={singInLink.linkUrl} className='delivery-signin-link'>
          {translateWithI18Next(singInLink.linkText)}
        </AnchorWithLink>
      </span>
    </div>
  );
}
